<div class="page-content-wrapper">
    <div class="row">
        <div class="col-md-12">
        <div class="card shadow rounded-3 border-1">
            <div class="card-body">
                <docuseal-builder
                  id="docuseal-builder"
                  :data-token="token"
                  :data-autosave="true"
                  :data-with-title="true"
                  :data-with-upload-button="false"
                  :data-with-sign-yourself-button="false"
                  :data-with-send-button="false"
                  :data-only-defined-fields="true"
                  :data-fields="tags"
                  :data-template-id="id"
                  :data-name="template_name"
                  data-roles="CLIENT_ADMIN"
                >
                </docuseal-builder>
            </div>
        </div>
        </div>
    </div>
</div>